module.exports = __webpack_public_path__ + "img/mobile scanner stand-05.254fb4b7.png";